import { makeStyles } from "@material-ui/core/styles";

const useMissingRequiredDataModalStyles = makeStyles((theme) => ({
  paper: {
    width: "calc(100% - 32px)",
    maxWidth: 480,
    margin: theme.spacing(2),
    borderRadius: 8,
    backgroundColor: "#FFFFFF",
  },
  content: {
    padding: theme.spacing(5, 5, 0),
    textAlign: "center",
    "&:first-child": { paddingTop: theme.spacing(5) },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  errorIcon: {
    width: 88,
    height: 88,
    color: "#E00000",
  },
  title: {
    marginTop: theme.spacing(2.5),
    color: "#101B30",
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.4,
    letterSpacing: 0,
  },
  description: {
    marginTop: theme.spacing(2),
    color: "#586174",
    fontSize: 16,
    lineHeight: 1.8,
    letterSpacing: 0,
  },
  divider: {
    margin: theme.spacing(4, 0, 3.5),
    backgroundColor: "#E6E9EE",
  },
  detail: {
    display: "grid",
    gridTemplateColumns: "72px minmax(0, 1fr)",
    gap: theme.spacing(2.5),
    alignItems: "start",
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "56px minmax(0, 1fr)",
      gap: theme.spacing(2),
    },
  },
  clipboard: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FDE3E5",
    color: "#E00000",
    "& svg": { fontSize: 34 },
    [theme.breakpoints.down("xs")]: { width: 56, height: 56 },
  },
  detailText: {
    color: "#586174",
    fontSize: 16,
    lineHeight: 1.8,
    letterSpacing: 0,
  },
  actions: {
    justifyContent: "center",
    padding: theme.spacing(4.5, 3, 4),
  },
  acknowledgeButton: {
    width: 180,
    maxWidth: "100%",
    minHeight: 46,
    borderRadius: 4,
    boxShadow: "none",
    color: "#FFFFFF",
    backgroundColor: "#008F24",
    textTransform: "none",
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: 0,
    "&:hover": { backgroundColor: "#00761C", boxShadow: "none" },
  },
}));

export default useMissingRequiredDataModalStyles;
